const $window = $(window);
let windowWidth = $window.width();

// メディアクエリ
let mql = window.matchMedia('screen and (max-width: 1024px)');

// preload
import {preload} from "../include/module";
preload();

// resizing
import {resizing} from "../include/module";
resizing();

// ヘッダーの開閉
import {headerToggle} from "../include/module";
headerToggle();

// ページTOP
import {backToTop} from "../include/module";
backToTop();

// リンクのアニメーション
import {anchorScroll} from "../include/module";
anchorScroll();

// ヘッダーのスクロール
import {headerScroll} from "../include/module";
headerScroll();

// スクロールアニメーション
import {scrollAnimation} from "../include/module";
scrollAnimation();

$(window).on('load' , function() {

  setTimeout(function(){
    $('.sw-Loader').addClass("load")
  },200);

  setTimeout(function(){
    $('.sw-Loader').addClass("hidden")
  },650);

});

const loadingAnimation = () =>{
  let timer = 0;
  $(window).on('load' , function() {
    if (timer > 0) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      $('.js-loadAnimation').addClass('is-animated');
    }, 100);
  });
};
loadingAnimation();

const cutText = () => {
  $(window).on('load' , function() {
    $('.news-list dd').trunk8({
      fill: '…',
      lines: 1
    });
  });

  let timer = 0;
  $(window).on('resize' , function() {
    if (timer > 0) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      $('.news-list dd').trunk8({
        fill: '…',
        lines: 1
      });
    }, 100);
  });
};
cutText();




// YouTubeのモーダル
import {youtubeModal} from "../include/module";
youtubeModal();



// WEBPACK FOOTER //
// ./src/vaas/assets/js/news/script.js